module.exports = __webpack_public_path__ + "img/2a5358f3618540503a373bc9b47242f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo13.png
// module id = 921
// module chunks = 5